<template>
  <v-row no-gutters class="fill-height">
    <crud-factory :serviceName="serviceName" :crudDialog="crudDialog" />
  </v-row>
</template>

<script>
export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "tipus-exercicis",
      crudDialog: {
        large: false,
        createTitle: "Nou tipus d'exercici",
        modelKeyTitle: "nom",
      },
    }
  },
}
</script>

<style lang="scss" scoped />
